<span *ngIf="increment === 1">{{current}}</span>
<span *ngIf="increment === 0.01">{{current | number : '1.2-2'}}M</span>